export default '/@lang/products'
